import { ImmutableMap } from "@suse-o11y/immutable-map";
import type { Record } from "@suse-o11y/record";
import type { RequestStatus } from "@suse-o11y/request-status";

import type { NodeId } from "~/models/dto";

export interface StackPackConfigurationState {
	fields: Record<string, string>;
	stackPacksProvisionStatus?: RequestStatus<Error, true>;
	stackPacksDeprovisionStatus?: RequestStatus<Error, true>;
	stackPackConfirmStatus?: RequestStatus<Error, true>;
}

export interface StackPacksDetailsState {
	configs: ImmutableMap<NodeId, StackPackConfigurationState>;
	config?: StackPackConfigurationState;
}

export const initialStackPackDetailsConfigurationState: StackPackConfigurationState = {
	stackPacksProvisionStatus: undefined,
	stackPacksDeprovisionStatus: undefined,
	stackPackConfirmStatus: undefined,
	fields: {},
};

export const initialStackPackConfigurationState: StackPackConfigurationState = {
	fields: {},
	stackPacksDeprovisionStatus: undefined,
	stackPacksProvisionStatus: undefined,
	stackPackConfirmStatus: undefined,
};

export const initialStackPacksDetailsState: StackPacksDetailsState = {
	configs: ImmutableMap.empty(),
	config: undefined,
};
